
































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { mdbTooltip, mdbBtn, mdbRow, mdbCol, mdbInput, mdbAlert, mdbSelect, mdbIcon, mdbChipInput, mdbCard, mdbCardImage, mdbView, mdbMask, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { State } from '@/models/globalization/state';
import { BusinessShippingRate } from '@/models/businesses/business-shipping-rate';
import { BusinessShippingRateService } from '@/models/businesses/business-shipping-rate-service';
import { ShippingRateTerritorialScope } from '@/models/common/shipping-rate-territorial-scope';
import { usersService, businessesShippingRatesService, businessPaymentOptionsService, globalizationService, notificationsService } from '@/services';
import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbTooltip,
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbSelect,
        mdbIcon,
        mdbChipInput,
        mdbCard,
        mdbCardImage,
        mdbView,
        mdbMask,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    },
    validations: {
        shippingRate: {
            name: { required },
            description: { required }
        },
        shippingRateService: {
            price: { required },
            minimumPurchasePrice: {
                required: requiredIf(model => {
                    return model.minimumPurchaseEnabled;
                })
            },
            freeShippingPrice: {
                required: requiredIf(model => {
                    return model.freeShippingEnabled;
                })
            }
        }
    }
})
export default class EditBusinessLogisticsShippingRateView extends Vue {
    private shippingRate: BusinessShippingRate = new BusinessShippingRate();
    private shippingRateService: BusinessShippingRateService = new BusinessShippingRateService();
    private destinations: any[] = [];
    private states: State[] = [];
    private prices: any[] = [];
    private price: string = '';
    private eta: string = '';
    private minimumPurchasePrice: string = '';
    private freeShippingPrice: string = '';

    private showStatesSelection: boolean = false;
    private showPostalCodesInput: boolean = false;
    private showFixedPrice: boolean = false;

    private statesValidationError: boolean = false;
    private postalCodesValidationError: boolean = false;

    private savingData: boolean = false;

    private async mounted(): Promise<void> {
        if (this.$route.params.shippingRateId) {
            this.$root.$emit('change-active-page', this.$t('views.businesses.editBusinessLogisticsShippingRateView.editTitle'), this.$route.query.shippingRateName);
            this.shippingRate = await businessesShippingRatesService.getBusinessShippingRate(+this.$route.params.id, +this.$route.params.shippingRateId);
        } else {
            this.$root.$emit('change-active-page', this.$t('views.businesses.editBusinessLogisticsShippingRateView.newTitle'), this.$route.query.businessName ? this.$route.query.businessName : '...');
            const businessPaymentOptions = await businessPaymentOptionsService.getPaymentOptions(+this.$route.params.id);
            this.shippingRate = new BusinessShippingRate({
                id: 0,
                businessId: +this.$route.params.id,
                businessAllowedPaymentOnHandingOver: businessPaymentOptions && businessPaymentOptions.paymentOnHandingOver && businessPaymentOptions.paymentOnHandingOver.isAllowed,
                origin: {
                    scope: ShippingRateTerritorialScope.PostalCode,
                    countryId: 1,
                    stateIds: [this.$route.query.stateId],
                    postalCodes: [this.$route.query.postalCode]
                },
                services: [
                    {
                        destination: {
                            scope: ShippingRateTerritorialScope.National,
                            countryId: 1,
                            price: null
                        }
                    }
                ]
            });
        }
        this.shippingRateService = this.shippingRate.services[0];

        this.prices.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.price.options.free'),
            value: 1,
            selected: false
        });
        this.prices.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.price.options.fixedPrice'),
            value: 2,
            selected: false
        });

        if (this.shippingRateService.price && this.shippingRateService.price > 0) {
            this.prices[1].selected = true;
        } else {
            this.prices[0].selected = true;
        }

        if (this.shippingRateService.price != null) {
            this.price = this.shippingRateService.price.toString(10);
        }
        this.$watch('price', (newValue: string, oldValue: string) => {
            const price = (this.$refs.price as any).$refs.input.$ci.numberValue;
            this.shippingRateService.price = newValue && price !== undefined && price !== null ? price : null;
        });

        if (this.shippingRateService.eta) {
            this.eta = this.shippingRateService.eta;
        }

        this.states = await globalizationService.getStates(this.shippingRateService.destination.countryId);

        this.destinations.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.geographicScope.spain'),
            value: 1,
            selected: false
        });
        this.destinations.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.geographicScope.spainContinental'),
            value: 2,
            selected: false
        });
        this.destinations.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.geographicScope.spainProvinces'),
            value: 3,
            selected: false
        });
        this.destinations.push({
            text: this.$t('views.businesses.editBusinessLogisticsShippingRateView.geographicScope.spainPostcodes'),
            value: 4,
            selected: false
        });

        switch (this.shippingRateService.destination.scope) {
            case ShippingRateTerritorialScope.National:
                this.destinations[0].selected = true;
                break;
            case ShippingRateTerritorialScope.Provincial:
                const mainlandStateIds = this.states.map(state => state.id).filter(stateId => ![7, 35, 38, 51, 52].some(id => id === stateId));
                const shippingRateServiceMainlandStateIds = this.shippingRateService.destination.stateIds!.filter(stateId => ![7, 35, 38, 51, 52].some(id => id === stateId));
                if (mainlandStateIds.length === shippingRateServiceMainlandStateIds.length) {
                    this.destinations[1].selected = true;
                } else {
                    this.destinations[2].selected = true;
                }
                break;
            case ShippingRateTerritorialScope.PostalCode:
                this.destinations[3].selected = true;
                break;
            default:
                break;
        }

        if (this.shippingRateService.minimumPurchasePrice != null) {
            this.minimumPurchasePrice = this.shippingRateService.minimumPurchasePrice.toString(10);
        }
        this.$watch('minimumPurchasePrice', (newValue: string, oldValue: string) => {
            const minimumPurchasePrice = (this.$refs.minimumPurchasePrice as any).$refs.input.$ci.numberValue;
            this.shippingRateService.minimumPurchasePrice = newValue && minimumPurchasePrice !== undefined && minimumPurchasePrice !== null ? minimumPurchasePrice : null;
        });

        if (this.shippingRateService.freeShippingPrice != null) {
            this.freeShippingPrice = this.shippingRateService.freeShippingPrice.toString(10);
        }
        this.$watch('freeShippingPrice', (newValue: string, oldValue: string) => {
            const freeShippingPrice = (this.$refs.freeShippingPrice as any).$refs.input.$ci.numberValue;
            this.shippingRateService.freeShippingPrice = newValue && freeShippingPrice !== undefined && freeShippingPrice !== null ? freeShippingPrice : null;
        });

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.ShippingRate,
                entityId: +this.$route.params.id
            })
        );
    }

    private async onChangeDestination(value: number, text: string): Promise<void> {
        this.showStatesSelection = false;
        this.showPostalCodesInput = false;

        if (value === 1) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.National;
        } else if (value === 2 || value === 3) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.Provincial;
            if (value === 3) {
                this.showStatesSelection = true;
                this.states.forEach(state => {
                    if (this.shippingRateService.destination.stateIds && this.shippingRateService.destination.stateIds.some(stateId => stateId === state.id)) {
                        state.selected = true;
                    }
                });
            }
        } else if (value === 4) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.PostalCode;
            this.showPostalCodesInput = true;
        }
    }

    private onChangeStates(values: number[], texts: string[]): void {
        this.states.forEach(state => {
            state.selected = false;
        });

        if (values && values.length > 0) {
            values.forEach(value => {
                const selectedState = this.states.find(state => state.id === value);
                selectedState!.selected = true;
            });
        }
    }

    private onChangePrice(value: number, text: string) {
        this.showFixedPrice = false;
        if (value === 1) {
            this.price = '';
        } else if (value === 2) {
            this.showFixedPrice = true;
        }
    }

    private hasErrors(): boolean {
        if (this.prices[0].selected) {
            this.shippingRateService.price = 0;
        }

        this.$v.shippingRate.$touch();
        this.$v.shippingRateService.$touch();
        this.statesValidationError = this.destinations[2].selected === true && !this.states.some(state => state.selected);
        this.postalCodesValidationError = this.destinations[3].selected === true && this.shippingRateService.destination.postalCodes.length < 1;

        if (this.$v.shippingRate.$error || this.$v.shippingRateService.$error || this.statesValidationError || this.postalCodesValidationError) {
            return true;
        }

        const destination: any = this.destinations.find(d => d.selected)!;
        if (destination.value === 1) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.National;
            this.shippingRateService.destination.stateIds = [];
            this.shippingRateService.destination.postalCodes = [];
        } else if (destination.value === 2 || destination.value === 3) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.Provincial;
            this.shippingRateService.destination.stateIds =
                destination.value === 2 ? this.states.map(state => state.id).filter(stateId => ![7, 35, 38, 51, 52].some(id => id === stateId)) : this.states.filter(state => state.selected).map(state => state.id);
            this.shippingRateService.destination.postalCodes = [];
        } else if (destination.value === 4) {
            this.shippingRateService.destination.scope = ShippingRateTerritorialScope.PostalCode;
            this.shippingRateService.destination.stateIds = [];
        }

        if (!this.shippingRateService.minimumPurchaseEnabled) {
            this.shippingRateService.minimumPurchasePrice = null;
        }
        if (!this.shippingRateService.freeShippingEnabled) {
            this.shippingRateService.freeShippingPrice = null;
        }

        return false;
    }

    private scrollUpWhenHasErrors(): void {
        this.$nextTick(() => {
            if (document.querySelector('.invalid-feedback') && document.querySelector('.invalid-feedback')!.parentElement) {
                const domRect = document.querySelector('.invalid-feedback')!.parentElement!.getBoundingClientRect();
                window.scrollTo(domRect.left + document.documentElement.scrollLeft, domRect.top + document.documentElement.scrollTop - domRect.height);
            }
        });
    }

    private async saveChanges(): Promise<void> {
        this.savingData = true;

        if (this.hasErrors()) {
            this.savingData = false;
            this.scrollUpWhenHasErrors();
            return;
        }

        try {
            if (this.shippingRate.id > 0) {
                if (await businessesShippingRatesService.updateBusinessShippingRate(+this.$route.params.id, this.shippingRate)) {
                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessShippingRate.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.ShippingRate,
                            entityId: +this.$route.params.id
                        })
                    );

                    this.$router.back();
                    return;
                }
            } else {
                if (await businessesShippingRatesService.newBusinessShippingRate(+this.$route.params.id, this.shippingRate)) {
                    notificationsService.showToastSuccessNotification('views.businesses.businessLogisticsView.notifications.saveBusinessShippingRate.success');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasCreated,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.ShippingRate,
                            entityId: +this.$route.params.id
                        })
                    );

                    this.$router.back();
                    return;
                }
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingData = false;
        }
    }
}
